/** Stack of open bottom sliders so document-level swipe only closes the top one. */

let nextId = 1;
const stack: number[] = [];

export function createBottomSliderSwipeId(): number {
    return nextId++;
}

/** Call when a slider becomes visible (last pushed = top / most recently opened). */
export function pushBottomSliderSwipe(id: number): void {
    const filtered = stack.filter((x) => x !== id);
    filtered.push(id);
    stack.length = 0;
    stack.push(...filtered);
}

/** Call when a slider is hidden or unmounted. */
export function popBottomSliderSwipe(id: number): void {
    const idx = stack.indexOf(id);
    if (idx !== -1) {
        stack.splice(idx, 1);
    }
}

export function isTopBottomSliderSwipe(id: number): boolean {
    return stack.length > 0 && stack[stack.length - 1] === id;
}
